import React, { memo } from 'react';
import PropTypes from 'prop-types';

const ProductsTableMobile = ({ products }) => {
  return (
    <div className="cases-table-mobile">
      {products.map((product) => {
        return (
          <div key={product.id} className="case-mobile-row">
            <div className="d-flex space-between m-t-sm">
              <div className="m-r-md flex-1">{product.sku}</div>
            </div>
            <div className="d-flex space-between m-t-sm">
              <div className="secondary">
                {product.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

ProductsTableMobile.propTypes = {
  products: PropTypes.array,
};

export default memo(ProductsTableMobile);
